import React, { useState } from 'react';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    news: false,
  });

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // You can send form data to your server here
    console.log(formData);
    // Reset the form after submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
      news: false,
    });
  };

  return (

   <>
    <div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>Contact Us</h2>
            <ul className="bread-list">
              <li><a href="/">Home</a></li>
              <li><i className="icofont-simple-right"></i></li>
              <li className="active">Contact Us</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  
    <section className="contact-us section">
      <div className="container">
    

        {/* Contact Info */}
        <div className="contact-info">
          <div className="row">
            {/* Single Info */}
            <div className="col-lg-4 col-12">
  <div className="single-info">
    {/* Phone Icon */}
    <i className="icofont icofont-ui-call"></i>
    <div className="content">
      <a href="tel:+918956322311" className="phone-link">
        <h3>+91 8956322311</h3>
      </a>
      <a href="tel:+918421773700" className="phone-link">
        <h3>+91 8421773700</h3>
      </a>
    </div>
  </div>
</div>


            <div className="col-lg-4 col-12">
  <div className="single-info">
    {/* IcoFont email icon */}
    <i className="far fa-envelope"></i>
    <div className="content">
      <a href="mailto:info@wallabieswarmcares.com" className="email-link text-white">
        info@wallabieswarmcares.com
      </a>
    </div>
  </div>
</div>


            {/* Single Info */}
            <div className="col-lg-4 col-12">
              <div className="single-info">
                <i className="icofont-google-map"></i>
                <div className="content">
                  <h3>Pharmacle Health Care Private Limited</h3>
                  <p>Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208</p>
                </div>
              </div>
            </div>

     
          </div>
        </div>

        
      </div>

   
    </section>
    <div className="col-12">
              <div className="contact-us-left">
                <div id="myMap">
                  {/* <iframe
                    id="gmap_canvas"
                    title="Google Map"
                    src="https://maps.google.com/maps?q=new%20york&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    width="100%"
                    height="350"
                    frameBorder="0"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex="0"
                  ></iframe> */}

<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d373.40863569613407!2d74.10570255094024!3d18.681534195083994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2db0049ab370b%3A0x5c50a91a7f7ad2e3!2sPharmacle%20Health%20care%20Pvt%20Ltd!5e1!3m2!1sen!2sin!4v1744026241474!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                </div>
              </div>
            </div>
   </>
  );
};

export default ContactUs;
